module.exports = __webpack_public_path__ + "static/img/wq-9.7481859.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/wq-9.png
// module id = H+LR
// module chunks = 0